import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import {
  ADDRESS_LOADING,
  ADDRESS_SUCCESS,
  ADDRESS_FAILED,
  ADDRESS_ADD_LOADING,
  ADDRESS_ADD_SUCCESS,
  ADDRESS_ADD_FAILED,
  ADDRESS_REMOVE_LOADING,
  ADDRESS_REMOVE_SUCCESS,
  ADDRESS_REMOVE_FAILED,
  ADDRESS_UPDATE_QUESTION_LOADING,
  ADDRESS_UPDATE_QUESTION_SUCCESS,
  ADDRESS_UPDATE_QUESTION_FAILED,
  ADDRESS_SAVE_LOADING,
  ADDRESS_SAVE_SUCCESS,
  ADDRESS_SAVE_FAILED,
  ADDRESS_VALIDATION_LOADING,
  ADDRESS_VALIDATION_SUCCESS,
  ADDRESS_VALIDATION_FAILED,
  ADDRESS_SAVE_NEW_LOADING,
  ADDRESS_SAVE_NEW_SUCCESS,
  ADDRESS_SAVE_NEW_FAILED,
  ADDRESS_VALIDATION_NEW_LOADING,
  ADDRESS_VALIDATION_NEW_SUCCESS,
  ADDRESS_VALIDATION_NEW_FAILED,
  ADDRESS_ADD_NEW_LOADING,
  ADDRESS_ADD_NEW_SUCCESS,
  ADDRESS_ADD_NEW_FAILED
} from "../Constants/addressConstants";

import { handleApiError } from "../Helper/actionHelper";

export const getAddress = (deletIdx, callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: ADDRESS_LOADING });
    const requestData = {
      token:
      userLocalData.id,
        "group": 2,
        "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/checkDetail",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: ADDRESS_SUCCESS,
      payload: data,
    });
    callback(data?.data, deletIdx);

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    dispatch({
      type: ADDRESS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
}; 

export const clearAddress = () => async (dispatch) => {
    dispatch({
      type: ADDRESS_SUCCESS,
      payload: [],
    });
}; 


export const addAddress = (lastRecordData, callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_ADD_LOADING });

    const requestData = {
      token:
      userLocalData.id,
        // "group": 3,
        // "referenceNo": "1234567890"
      check_details : lastRecordData
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/addAddressCheck",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: ADDRESS_ADD_SUCCESS,
      payload: data,
    });
    callback();
    handleApiError(data); 
    if(data.status == "error"){
      const msg = data.message;

    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    }

  } catch (error) {
    dispatch({
      type: ADDRESS_ADD_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const addNewAddress = (savePostAddCb=()=>{}, callback=()=>{}, payload = {}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_ADD_NEW_LOADING });

    const requestData = {
      token:
      userLocalData.id,
        // "group": 3,
        // "referenceNo": "1234567890"
      // check_details : lastRecordData
      ...payload
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/AddressApi/addAddressChecks",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: ADDRESS_ADD_NEW_SUCCESS,
      payload: data,
    });
    callback();
    savePostAddCb(data);
    handleApiError(data); 
    if(data.status == "error"){
      const msg = data.message;

    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    }

  } catch (error) {
    dispatch({
      type: ADDRESS_ADD_NEW_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const deleteAddNewAddress = () => (dispatch) => {
  dispatch({
    type: ADDRESS_ADD_NEW_SUCCESS,
    payload: [],
  });
};



export const updateQuestionAddress = (value) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_UPDATE_QUESTION_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      addrCntr:value,
        // "group": 3,
        // "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/updateAddressChecksCount",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: ADDRESS_UPDATE_QUESTION_SUCCESS,
      payload: data,
    });
    handleApiError(data); 

  } catch (error) {
    dispatch({
      type: ADDRESS_UPDATE_QUESTION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};



export const removeAddress = (caseCheckId, callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_REMOVE_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      casechkid:caseCheckId,
        // "group": 3,
        // "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/removeAddressCheck",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: ADDRESS_REMOVE_SUCCESS,
      payload: data,
    });
   callback(data);
   handleApiError(data); 

  } catch (error) {
    dispatch({
      type: ADDRESS_REMOVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const deleteRemoveAddress = () => (dispatch) => {
  dispatch({
    type: ADDRESS_REMOVE_SUCCESS,
    payload: [],
  });
};


export const saveAddress = (record) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_SAVE_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data:result } = await axios.post(FOLDERPATH + 
      "/CandidateApi/saveCheckDetails",
      requestData,
      {
        headers: headers,
      } 
    );

    if (result.status === "success") {

      const { data } = result;

    dispatch({
      type: ADDRESS_SAVE_SUCCESS,
      payload: data,
    });
    

    const msg = "Saved Successfully";

    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });


  }
 // handleApiError(result); 

  } catch (error) {
    dispatch({
      type: ADDRESS_SAVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};



export const validateAddress = (record) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_VALIDATION_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data:result } = await axios.post(FOLDERPATH + 
      "/CandidateApi/addressValidation",
      requestData,
      {
        headers: headers,
      } 
    );

    if (result.status === "success") {

      const { data } = result;

    dispatch({
      type: ADDRESS_VALIDATION_SUCCESS,
      payload: data,
      record: record
    });

    const msg = "Saved Successfully";

    // toast.success(msg, {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });


  }
 // handleApiError(result); 

  } catch (error) {
    dispatch({
      type: ADDRESS_VALIDATION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const deleteValidateAddress = () => (dispatch) => {
  dispatch({
    type: ADDRESS_VALIDATION_SUCCESS,
    payload: [],
  });
  dispatch({
    type: ADDRESS_VALIDATION_NEW_SUCCESS,
    payload: [],
  });
};

export const deleteSaveAddress = () => (dispatch) => {
  dispatch({
    type: ADDRESS_SAVE_SUCCESS,
    payload: [],
  });
  dispatch({
    type: ADDRESS_SAVE_NEW_SUCCESS,
    payload: [],
  });
};

export const saveNewAddress = (record) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_SAVE_NEW_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data:result } = await axios.post(FOLDERPATH  +
      "/AddressApi/saveAddressCheckDetails",
      requestData,
      {
        headers: headers,
      } 
    );

    if (result.status === "success") {

      const { data } = result;

    dispatch({
      type: ADDRESS_SAVE_NEW_SUCCESS,
      payload: data,
    });
    

    const msg = "Saved Successfully";

    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });


  }
 // handleApiError(result); 

  } catch (error) {
    dispatch({
      type: ADDRESS_SAVE_NEW_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const validateNewAddress = (record, callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: ADDRESS_VALIDATION_NEW_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data:result } = await axios.post(FOLDERPATH  +
      "/AddressApi/validateAddress",
      requestData,
      {
        headers: headers,
      } 
    );

    if (result.status === "success") {

      const { data } = result;

    dispatch({
      type: ADDRESS_VALIDATION_NEW_SUCCESS,
      payload: data,
      record: record
    });

    const msg = "Saved Successfully";

    callback(record, result?.data);    

    // toast.success(msg, {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });


  }
 // handleApiError(result); 

  } catch (error) {
    dispatch({
      type: ADDRESS_VALIDATION_NEW_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    //handleApiError(error); 
  }
};

export const deleteDataForNo = (record, callback=()=>{}) => async (dispatch) => {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

      let data=await axios.post(FOLDERPATH  +
      "/AddressApi/removeCaseCheckData",
      requestData,
      {
        headers: headers,
      } 
    );

    if(data?.data?.status == "success"){
      return data?.data?.status;
    }

};

// export const sendPersonalDetails = (formData) => async (dispatch) => {
//   try {
//     dispatch({ type: SAVE_PERSONAL_DETAILS_LOADING });
//     const requestData = {
//       token:
//         "GOaNMmi/iOhOGjFhu9AvptrNjxpus9dsMUmb5LwTq5Y=:dbvJdVvhe5dqiC33I3oXpA==",
//     };
//     for (var i in formData) {
//       if (i === "customfields_data") {
//         requestData[i] = formData[i];
//       } else if (formData[i].length > 0) {
//         requestData[i] = formData[i];
//       }
//     }
//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };

//     const { data } = await axios.post(FOLDERPATH + 
//       "/idemo/CandidateApi/saveProfileDetails",
//       requestData,
//       {
//         headers: headers,
//       }
//     );
//     console.log(data);
//     dispatch({
//       type: SAVE_PERSONAL_DETAILS_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: SAVE_PERSONAL_DETAILS_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//   }
// };

// export const uploadFileViaMultipart = (mode, file) => async (dispatch) => {
//   try {
//     dispatch({ type: UPLOAD_FILE_MULTIPART_LOADING });

//     let formData = new FormData();
//     formData.append(
//       "token",
//       "GOaNMmi/iOhOGjFhu9AvptrNjxpus9dsMUmb5LwTq5Y=:dbvJdVvhe5dqiC33I3oXpA=="
//     );
//     formData.append("mode", mode);
//     formData.append(mode, file);

//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };

//     const { data } = await axios.post(FOLDERPATH + 
//       "/idemo/CandidateApi/uploadFiles",
//       formData,
//       {
//         headers,
//       }
//     );

//     dispatch({
//       type: UPLOAD_FILE_MULTIPART_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: UPLOAD_FILE_MULTIPART_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//   }
// };
